import React from "react";
import { redirect, Route } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import UsersTab, { usersTabLoader } from "./UsersTab/UsersTab";
import User, { userLoader } from "./UsersTab/User/User";
import { testSessionLoader } from "../../loaders/helpers";
import UserUpdateForm, {
  userUpdateAction,
} from "./UsersTab/User/UserForm/UserUpdateForm";
import UserLayout from "./UsersTab/User/UserLayout";
import UserPasswordUpdateForm, {
  userPasswordUpdateAction,
} from "./UsersTab/User/UserPasswordUpdateForm/UserPasswordUpdateForm";
import EmailsTab, { emailsTabLoader } from "./EmailsTab/EmailsTab";
import EmailLayout from "./EmailsTab/Email/EmailLayout";
import Email, { emailLoader } from "./EmailsTab/Email/Email";
import SearchTab, { searchTabLoader } from "./SearchTab/SearchTab";
import ContactsTab, { contactsTabLoader } from "./ContactsTab/ContactsTab";
import ContactLayout from "./ContactsTab/Contact/ContactLayout";
import Contact, { contactLoader } from "./ContactsTab/Contact/Contact";
import ContactUpdateForm, {
  contactUpdateAction,
} from "./ContactsTab/Contact/ContactForm/ContactUpdateForm";
import ImagesTab, { imagesTabLoader } from "./ImagesTab/ImagesTab";
import ImageLayout from "./ImagesTab/Image/ImageLayout";
import Image, { imageLoader } from "./ImagesTab/Image/Image";
import ImageUpdateForm, {
  imageUpdateAction,
} from "./ImagesTab/Image/ImageForm/ImageUpdateForm";
import ContactCreateForm, {
  contactCreateAction,
} from "./ContactsTab/Contact/ContactForm/ContactCreateForm";
import OperationsTab from "./OperationsTab/OperationsTab";
import AnnouncementsTab, {
  announcementsTabLoader,
} from "./AnnouncementsTab/AnnouncementsTab";
import AnnouncementCreateForm, {
  announcementCreateAction,
} from "./AnnouncementsTab/Announcement/AnnouncementForm/AnnouncementCreateForm";
import AnnouncementLayout
  from "./AnnouncementsTab/Announcement/AnnouncementLayout";
import Announcement, {
  announcementLoader,
} from "./AnnouncementsTab/Announcement/Announcement";
import AnnouncementUpdateForm, {
  announcementUpdateAction,
} from "./AnnouncementsTab/Announcement/AnnouncementForm/AnnouncementUpdateForm";

const adminRoutes = (
  <Route>
    <Route
      index
      loader={async (params) => {
        await testSessionLoader(params);
        return redirect("users");
      }}
    />
    <Route
      path="users"
    >
      <Route
        index
        id="adminUserTab"
        element={<UsersTab/>}
        loader={usersTabLoader}
      />
      <Route
        path=":id"
        id="adminUser"
        element={<UserLayout/>}
        loader={userLoader}
      >
        <Route
          index
          element={<User/>}
        />
        <Route
          path="update"
          element={<UserUpdateForm/>}
          action={userUpdateAction}
        />
        <Route
          path="updatePassword"
          element={<UserPasswordUpdateForm/>}
          action={userPasswordUpdateAction}
        />
      </Route>
    </Route>
    <Route
      path="emails"
      id="adminUserEmails"
      loader={emailsTabLoader}
    >
      <Route
        index
        element={<EmailsTab/>}
      />
      <Route
        path=":id"
        id="adminUserEmail"
        element={<EmailLayout/>}
        loader={emailLoader}
      >
        <Route
          index
          element={<Email/>}
        />
      </Route>
    </Route>
    <Route path="contacts">
      <Route
        index
        element={<ContactsTab/>}
        loader={contactsTabLoader}
      />
      <Route
        path="create"
        element={<ContactCreateForm/>}
        action={contactCreateAction}
      />
      <Route
        path=":id"
        id="adminContact"
        element={<ContactLayout/>}
        loader={contactLoader}
      >
        <Route
          index
          element={<Contact/>}
        />
        <Route
          path="update"
          element={<ContactUpdateForm/>}
          action={contactUpdateAction}
        />
      </Route>
    </Route>
    <Route path="announcements">
      <Route
        index
        element={<AnnouncementsTab/>}
        loader={announcementsTabLoader}
      />
      <Route
        path="create"
        element={<AnnouncementCreateForm/>}
        action={announcementCreateAction}
      />
      <Route
        path=":id"
        id="adminAnnouncement"
        element={<AnnouncementLayout/>}
        loader={announcementLoader}
      >
        <Route
          index
          element={<Announcement/>}
        />
        <Route
          path="update"
          element={<AnnouncementUpdateForm/>}
          action={announcementUpdateAction}
        />
      </Route>
    </Route>
    <Route path="images">
      <Route
        index
        element={<ImagesTab/>}
        loader={imagesTabLoader}
      />
      <Route
        path=":id"
        id="adminImage"
        loader={imageLoader}
        element={<ImageLayout/>}
      >
        <Route
          index
          element={<Image/>}
        />
        <Route
          path="update"
          element={<ImageUpdateForm/>}
          action={imageUpdateAction}
        />
      </Route>
    </Route>
    <Route
      path="operations"
      element={<OperationsTab/>}
    />
    <Route
      path="search"
      element={<SearchTab/>}
      loader={searchTabLoader}
    />
  </Route>);

const AdminComponent = ({ ...props }) => {
  return <AdminLayout {...props}/>;
};

export { adminRoutes };
export default AdminComponent;